import React, { useEffect, useState } from 'react'
import { IoSearch } from 'react-icons/io5';
import ReactInputMask from 'react-input-mask';
import { classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasAzul, classbtColunasVermelho } from '../../Utils/Types';

type Props = {
    visible: boolean;
    loading?: boolean;
    CloseModalEvent: React.MouseEventHandler<HTMLButtonElement>;
    ConsultarCNPJEvent: (cnpj: string) => void;
}

export const ModalConsultaCNPJ = React.memo(({ visible, loading, CloseModalEvent, ConsultarCNPJEvent }: Props) => {

    const [cnpj, setCnpj] = useState("")

    useEffect(() => {
        setCnpj('')

        if (visible) {

            let modal = document.getElementById('modal_consulta_cnpj');
            let modalContent = document.getElementById('modal-content-consulta-cnpj');

            if (modal) {
                modal.style.visibility = 'visible';

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]');
                    modalContent.classList.add('mt-24');
                }

                const aguarde = setTimeout(() => {
                    const inputCNPJ = document.getElementById('inputCNPJ')
                    if (inputCNPJ) {
                        inputCNPJ.focus()
                        clearTimeout(aguarde)
                    }
                }, 200)
            }

        } else {

            let modal = document.getElementById('modal_consulta_cnpj');
            let modalContent = document.getElementById('modal-content-consulta-cnpj');

            if (modal) {
                modal.style.visibility = 'hidden';


                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]');
                    modalContent.classList.remove('mt-24');
                }
            }
        }

    }, [visible])

    const handleCNPJChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCnpj(e.target.value.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', ''))
    }

    const handleKeyPressEnter = async (event: any) => {

        if ((event.code === "Enter" || event.code === "NumpadEnter") && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Enter'
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab' && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleTabPress)

        return () => {

            document.addEventListener('keydown', handleKeyPressEnter)
            document.addEventListener('keydown', handleTabPress)
        }
    }, [visible]);

    return (

        <div id="modal_consulta_cnpj" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal-content-consulta-cnpj" className={`relative flex flex-col w-[80%] sm:w-[50%] md:w-[40%] lg:w-[30%] xl:w-[20%] h-[230px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <IoSearch size={20} className='w-5 h-5 text-slate-800 dark:text-slate-100' />
                    </div>
                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Consulta de CNPJ</span>
                </div>

                <div className={`absolute top-[70px] w-full h-full px-3 py-4`}>

                    <div className={`relative w-full col-span-4`}>
                        <ReactInputMask mask="99.999.999\/9999-99" id='inputCNPJ' className={`${classInput} ${classInputDark} h-[48px]`} placeholder='Digite o CNPJ desejado' value={cnpj} onChange={handleCNPJChange} autoComplete='off' />
                        <label htmlFor="inputCNPJ" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>CNPJ</label>
                    </div>

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        tabIndex={-1}
                        onClick={CloseModalEvent} disabled={loading}
                        className={`${classbtColunasVermelho} w-full`}>
                        CANCELAR
                    </button>

                    <button
                        tabIndex={-1}
                        onClick={() => ConsultarCNPJEvent(cnpj)} disabled={loading}
                        className={`${classbtAzul} ${classBt} w-full`}>

                        {loading &&
                            <div className="h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
                                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                            </div>
                        }
                        {!loading ? `CONSULTAR` : "AGUARDE"}

                    </button>

                    {/* Footer */}

                </div>

            </div>

        </div>
    )

})